import createSlateEditList from '@guestbell/slate-edit-list';
import createListItemPlugin from './createListItemPlugin';
import createSimpleHtmlBlockPlugin from './createSimpleHtmlBlockPlugin';
function createListPlugin(def) {
    var slateEditList = createSlateEditList({
        typeItem: def.listItem.type,
        types: [def.type],
    });
    return function (customizers) {
        return [
            createSimpleHtmlBlockPlugin({
                type: def.type,
                icon: def.icon,
                noButton: def.noButton,
                tagName: def.tagName,
                customAdd: function (editor) { return slateEditList.changes.wrapInList(editor, def.type); },
                customRemove: function (editor) { return slateEditList.changes.unwrapList(editor); },
            })(customizers && customizers.customizeList),
            createListItemPlugin(def.listItem)(customizers && customizers.customizeListItem),
            {
                onKeyDown: function (e, editor, next) {
                    return slateEditList.onKeyDown(e, editor, next);
                },
            },
        ];
    };
}
export default createListPlugin;
//# sourceMappingURL=createListPlugin.js.map